import React, { useEffect, useState, useCallback } from 'react';

import { roleDisplayValueMap } from '../../../../util/RoleUtil';

import { viewSiteStaff } from '../../../../services/FacilitiesService';

import { Table } from '../../../common/table/Table';
import { SelectableTable } from '../../../common/table/SelectableTable';
import { SaveButton } from '../../../common/button/save-button/SaveButton';

export const StaffAssignments = ({
  context,
  facilityExternalReference,
  setSpinnerText,
  showToaster,
  closeModal,
  setAssignedStaff,
  assignedStaff,
  setTabAssignedStaff,
  activeChildTab,
}) => {
  const [siteStaffRoleVOs, setSiteStaffRoleVOs] = useState([]);
  const [staffTableData, setStaffTableData] = useState([]);
  const [staffTableHeader, setStaffTableHeader] = useState('');
  const [hasStaff, setHasStaff] = useState(false);

  const handleViewRoleClick = useCallback(
    (role) => {
      const modifiedData = role.viewSiteStaffVOS.map((staff) => {
        const isAssignedToRole = assignedStaff.some(
          (s) => s.username === staff.username && s.studyRole === role.roleName
        );
        return {
          selected: isAssignedToRole, // Set selected based on assignment to current role
          firstName: staff.first,
          lastName: staff.lastName,
          username: staff.username,
          emailAddress: staff.email,
          studyRole: role.roleName,
          name: staff.name,
          personExternalReference: staff.personExternalReference,
        };
      });
      setStaffTableData(modifiedData);
      setStaffTableHeader('Staff: ' + (roleDisplayValueMap.get(role.roleName) ?? role.roleName));
    },
    [assignedStaff]
  );

  const retrieveSiteStaff = useCallback(async () => {
    setSpinnerText('Retrieving Staff');
    const [data, error] = await viewSiteStaff(context.username, facilityExternalReference);
    if (data) {
      if (data.responseStatus === 'Success') {
        const { viewSiteStaffRoleVOS } = data;
        setSiteStaffRoleVOs(viewSiteStaffRoleVOS);

        if (viewSiteStaffRoleVOS && viewSiteStaffRoleVOS.length > 0) {
          setHasStaff(true);
          handleViewRoleClick(viewSiteStaffRoleVOS[0]);
        }
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
    // This needs a more extensive refactor
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.username, facilityExternalReference, setSpinnerText, showToaster]);

  useEffect(() => {
    retrieveSiteStaff();
  }, [retrieveSiteStaff]);

  const handleSaveChangesClick = () => {
    setTabAssignedStaff((prevTabAssignedStaff) => ({
      ...prevTabAssignedStaff,
      [activeChildTab]: assignedStaff,
    }));

    closeModal();
  };

  const handleSelectedStaffChange = (selectedForms) => {
    setAssignedStaff((prevAssignedStaff) => {
      let updatedAssignedStaff = [...prevAssignedStaff];

      selectedForms.forEach((selectedUser) => {
        const { username, studyRole, selected } = selectedUser;

        const userIndex = updatedAssignedStaff.findIndex(
          (user) => user.username === username && user.studyRole === studyRole
        );

        if (userIndex !== -1) {
          if (!selected) {
            updatedAssignedStaff.splice(userIndex, 1);
          }
        } else {
          if (selected) {
            updatedAssignedStaff.push(selectedUser);
          }
        }
      });
      return updatedAssignedStaff;
    });
  };

  return (
    <div>
      <div className="form-section-site">
        <div className="staff-sections">
          <Table
            tableData={siteStaffRoleVOs.map((role) => ({
              ...role,
              role: roleDisplayValueMap.get(role.roleName) ?? role.roleName,
            }))}
            hiddenColumns={['viewSiteStaffVOS', 'roleName']}
            searchEnabled={true}
            filterEnabled={false}
            onRowClick={handleViewRoleClick}
            tableTitle={'Role Assignment'}
            maxRowCount={7}
            actionColumnEnabled={true}
            actionTwoClick={handleViewRoleClick}
            applyStyleChange={true}
          />
        </div>
        {hasStaff && (
          <div className="staff-sections">
            <SelectableTable
              tableData={staffTableData}
              hiddenColumns={[
                'personExternalReference',
                'selected',
                'firstName',
                'lastName',
                'username',
                'emailAddress',
                'studyRole',
              ]}
              searchEnabled={true}
              filterEnabled={false}
              tableTitle={staffTableHeader}
              buttonDisabled={true}
              maxRowCount={7}
              onSelectedFormsChange={handleSelectedStaffChange}
              selectedForms={assignedStaff}
              customHeaderName={'Assigned'}
            />
          </div>
        )}
      </div>
      <div className="staff-assignment-button-container">
        <SaveButton
          color={'#ffffff'}
          textColor="#6F8695"
          border="1px solid #6F8695"
          title={'Cancel'}
          onClick={closeModal}
        />
        <SaveButton color={'#6F8695'} title={'Done'} onClick={handleSaveChangesClick} />
      </div>
    </div>
  );
};
